import { useState, useEffect } from "react";
import { supabase } from "../lib/supabaseClient";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

export default function FeedbackForm({ qrId, ownerId }) {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [destinationUrl, setDestinationUrl] = useState("");
const [qrUUID, setQrUUID] = useState("");
const [qrOwnerId, setQrOwnerId] = useState(ownerId || "");

  // Fetch destination URL on mount
  useEffect(() => {
  async function getQRData() {
    const { data, error } = await supabase
      .from("qr_codes")
      .select("id, user_id, destination_url")
      .eq("code", qrId)
      .maybeSingle();
    if (error) console.error("Supabase Error:", error.message);
    if (data) {
      setQrUUID(data.id);
      setQrOwnerId(data.user_id);
      setDestinationUrl(data.destination_url);
    }
  }
  getQRData();
}, [qrId]);

  // When star is clicked — if 4 or 5, save silently and redirect immediately
  const handleRating = async (star) => {
    setRating(star);

    if (star >= 4) {
      // Save the positive rating silently (non-blocking)
      supabase.from("feedback").insert([{
  qr_code_id: qrUUID,
  user_id: qrOwnerId,
  rating: star,
}]);

      // Redirect immediately — don't wait for DB
      const target = destinationUrl || "https://www.digitoly.com";
      window.location.replace(target);
    }
    // If 3 or below, just set the rating and show the form below
  };

  // Low rating form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await supabase.from("feedback").insert([{
  qr_code_id: qrUUID,
  user_id: qrOwnerId,
  rating: rating,
  comment: comment,
  customer_name: name,
  customer_email: email,
  customer_phone: phone
}]);
    } catch (err) {
      console.error("Feedback Save Error:", err);
    } finally {
      setLoading(false);
      setSubmitted(true);
    }
  };

  // After low rating form submitted
  if (submitted) {
    return (
      <div className="min-h-screen bg-[#020617] flex flex-col items-center justify-center text-white p-4">
        <h1 className="text-2xl font-bold mb-4">Thank You</h1>
        <p className="text-center text-gray-400">
          We have received your feedback and will contact you shortly.
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#020617] flex flex-col items-center justify-center p-4">
      <style>{`
        .PhoneInputInput { background-color: rgba(255,255,255,0.05) !important; color: white !important; padding: 1.25rem !important; border-radius: 0 0.75rem 0.75rem 0 !important; border: 1px solid rgba(255,255,255,0.1) !important; border-left: none !important; outline: none !important; font-size: 16px !important; }
        .PhoneInputCountry { background: rgba(255,255,255,0.05); padding: 0 12px; border-radius: 0.75rem 0 0 0.75rem; border: 1px solid rgba(255,255,255,0.1); }
        .PhoneInputInput:focus { border-color: #3b82f6 !important; }
      `}</style>

      <div className="space-y-6 w-full max-w-md bg-slate-900/50 p-8 rounded-3xl border border-white/10">
        <div className="text-center mb-4">
          <h2 className="text-white text-xl font-black uppercase italic tracking-widest">Rate Your Experience</h2>
          <p className="text-gray-500 text-[10px] uppercase tracking-[5px] mt-1">We value your feedback</p>
        </div>

        {/* Star Rating */}
        <div className="flex justify-center space-x-2 mb-6">
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              key={star}
              type="button"
              onClick={() => handleRating(star)}
              className={`text-4xl transition-all ${rating >= star ? 'text-yellow-400 scale-110' : 'text-gray-700'}`}
            >
              ★
            </button>
          ))}
        </div>

        {/* Only show form for low ratings (1-3) */}
        {rating > 0 && rating <= 3 && (
          <form onSubmit={handleSubmit} className="space-y-4 animate-in fade-in duration-500">
            <div>
              <label className="text-[10px] font-black uppercase text-gray-500 ml-1 mb-1 block">Full Name</label>
              <input required placeholder="Enter your name" className="w-full p-4 bg-white/5 border border-white/10 rounded-xl text-white outline-none focus:border-blue-500 transition-all" value={name} onChange={(e) => setName(e.target.value)} />
            </div>

            <div>
              <label className="text-[10px] font-black uppercase text-gray-500 ml-1 mb-1 block">Email Address</label>
              <input required type="email" placeholder="name@company.com" className="w-full p-4 bg-white/5 border border-white/10 rounded-xl text-white outline-none focus:border-blue-500 transition-all" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>

            <div>
              <label className="text-[10px] font-black uppercase text-gray-500 ml-1 mb-1 block">WhatsApp / Phone</label>
              <PhoneInput international defaultCountry="IN" value={phone} onChange={setPhone} />
            </div>

            <div>
              <label className="text-[10px] font-black uppercase text-gray-500 ml-1 mb-1 block">How can we improve?</label>
              <textarea required placeholder="Tell us about your experience..." className="w-full p-4 bg-white/5 border border-white/10 rounded-xl text-white outline-none h-24 focus:border-blue-500 transition-all" value={comment} onChange={e => setComment(e.target.value)} />
            </div>

            <button disabled={loading} className={`w-full p-5 mt-4 rounded-2xl text-white font-black uppercase tracking-[3px] shadow-2xl transition-all ${loading ? "bg-gray-800 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-500 active:scale-95"}`}>
              {loading ? "Submitting..." : "Submit Feedback"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}